import { store } from "@/store/store";

export const getSidemenu = function(parentId, title) {
  let topmenus = store.state.topmenus;
  let sidemenu = null;
  let parentType;

  for (var i = 0; i < topmenus.length; i++) {
    if (topmenus[i].id == parentId) {
      parentType = "topmenu";
      sidemenu = topmenus[i];
    } else {
      let submenus = topmenus[i].childEntries.rows;
      for (var j = 0; j < submenus.length; j++) {
        if (submenus[j].id == parentId) {
          parentType = "submenu";
          sidemenu = topmenus[i];
        }
      }
    }
  }

  let sidemenuData = {
    menu: sidemenu,
    parentId: parentId,
    parentType: parentType,
    title: title
  };

  store.dispatch("setSidemenuData", sidemenuData);
};

export default {
  methods: {
    getSidemenu
  }
};
